import React, { useState, useEffect } from "react";
import moment from "moment";
import { AddCallLogsAPI, updateLeadAndCallLog } from "../../API/Api";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { openModal, setCallingStarted, startingTime, setApiResponsed,resetCallState, endingTime  } from "../../Redux/Slice/LoginSlice";
import StopwatchClock from "../StopwatchClock";
import { formBtn1, inputClass, labelClass } from "../Utils/CustomClasses";
import { Controller, useForm } from "react-hook-form";
import Error from "../Error/Error";
import { DatePicker, TimePicker } from "antd";
import dayjs from "dayjs";

export default function CallTimeComponent({ filterRecords }) {
  const userDetails = useSelector((state) => state?.login?.userDetails);
  const companyDetails = useSelector((state) => state?.login?.userDetails?.company);
  const leadStatusOptions = companyDetails?.allowedLeadStatus || [];
  const { register, handleSubmit, reset,control, setValue, formState: { errors, dirtyFields  }, } = useForm();
  const modalState = useSelector((state) => state?.login);
  const dispatch = useDispatch();
  const [showDateField, setShowDateField] = useState(false);
  const [showRejectedReason, setShowRejectedReason] = useState(false);
  const [minTime, setMinTime] = useState("");
  const [endTime, setEndTime] = useState(null);
  const [elapsedSeconds, setElapsedSeconds] = useState(0);
  const isIdle = !modalState.startingTime && !modalState.endingTime;
  const isRunning = modalState.startingTime && !modalState.endingTime;
  const isStopped = modalState.startingTime && modalState.endingTime;
  const { apiResponse } = useSelector((state) => state?.login);

  const selectedRow = (modalState?.modalData && modalState.modalData.rowdata);
  const handleStart = async () => {
    if (endTime) return;
    try {
      const start = new Date();
      const formattedStartTime = moment(start).format("YYYY-MM-DDTHH:mm:ss");
      dispatch(startingTime({ startingTime: formattedStartTime }));

      const response = await AddCallLogsAPI({
        userId: userDetails?._id,
        leadId: selectedRow?._id,
        callStart: formattedStartTime,
      });
      if (response?.status === 200) {
        setElapsedSeconds(0);
        dispatch(setCallingStarted(true));
        dispatch(setApiResponsed(response?.data?.data));
      } else {
        dispatch(setCallingStarted(false));
        dispatch(setApiResponsed({}));
        toast.error(response?.response?.data?.error);
      }
    } catch (error) {
      console.error("Error starting call:", error);
    }
  };

  const handleStop = () => {
    const end = moment().format("YYYY-MM-DDTHH:mm:ss");

    setEndTime(end);
    dispatch(endingTime({ endingTime: end })); // store in redux
    dispatch(setCallingStarted(false));
  };
  useEffect(() => {
  let interval;

  if (modalState.startingTime && !modalState.endingTime) {
    const start = new Date(modalState.startingTime);

    const update = () => {
      const now = new Date();
      setElapsedSeconds(
        Math.max(0, Math.floor((now - start) / 1000))
      );
    };

    update();
    interval = setInterval(update, 1000);
  }

  // STOPPED → FREEZE
  if (modalState.startingTime && modalState.endingTime) {
    const start = new Date(modalState.startingTime);
    const end = new Date(modalState.endingTime);

    setElapsedSeconds(
      Math.max(0, Math.floor((end - start) / 1000))
    );
  }

  return () => clearInterval(interval);
}, [modalState.startingTime, modalState.endingTime]);

  const formatTime = () => {
    const h = Math.floor(elapsedSeconds / 3600);
    const m = Math.floor((elapsedSeconds % 3600) / 60);
    const s = elapsedSeconds % 60;

    return `${String(h).padStart(2, "0")}:${String(m).padStart(
      2,
      "0"
    )}:${String(s).padStart(2, "0")}`;
  };

  useEffect(() => {
      reset({
        firstName: modalState?.modalData?.rowdata?.firstName ? modalState?.modalData?.rowdata?.firstName : "",
        lastName: modalState?.modalData?.rowdata?.lastName ? modalState?.modalData?.rowdata?.lastName : "",
        phoneNumber: String(modalState?.modalData?.rowdata?.phoneNumber ? modalState?.modalData?.rowdata?.phoneNumber : ""),
        alternateNumber: String(modalState?.modalData?.rowdata?.alternateNumber ? modalState?.modalData?.rowdata?.alternateNumber : ""),
        state: modalState?.modalData?.rowdata?.state ? modalState?.modalData?.rowdata?.state : "",
        pincode: modalState?.modalData?.rowdata?.pincode ? modalState?.modalData?.rowdata?.pincode : "",
        state: modalState?.modalData?.rowdata?.state ? modalState?.modalData?.rowdata?.state : "",
        city: modalState?.modalData?.rowdata?.city ? modalState?.modalData?.rowdata?.city : "",
      });
  },[]);

  const HandleStatusChange = (e) => {
    const value = e.target.value;
    if (value === "CallBack" || value === "FollowUp") {
      setShowDateField(true);
    } else {
      setShowDateField(false);
    }

    if (value === "Rejected") {
      setShowRejectedReason(true);
    } else {
      setShowRejectedReason(false);
    }
  };

  const handleDateChange = (e) => {
      const selectedDate = e.target.value;
      const today = moment().format("YYYY-MM-DD");
  
      setValue("followDate", selectedDate); 
      if (selectedDate === today) {
        const nextMinute = moment().add(1, "minutes").format("HH:mm");
        setMinTime(nextMinute);
      } else {
        setMinTime(""); 
      }
  };
  const DirtyFields = (values, dirty) => {
    const result = {};

    Object.keys(dirty).forEach((key) => {
      result[key] = values[key];
    });

    return result;
  };

  const onSave = async (formValues) => {

    const saveTimestamp = new Date();
    const formattedSaveTime = moment(saveTimestamp).format(
      "YYYY-MM-DDTHH:mm:ss"
    );

    const editedLeadInfo = DirtyFields(
    {
        firstName: formValues.firstName,
        lastName: formValues.lastName,
        phoneNumber: formValues.phoneNumber,
        alternateNumber: formValues.alternateNumber,
        state: formValues.state,
        city: formValues.city,
        pincode: formValues.pincode,
    },
      dirtyFields
    );
    const payload = {
      callLogId:apiResponse?._id,
      leadId: modalState?.modalData?.rowdata?._id,
      ...editedLeadInfo,
      ...(formValues.followDate && {
         followDate: formValues.followDate
      ? formValues.followDate.format("YYYY-MM-DD")
      : null
      }),
      ...(formValues.followTime && {
          followTime: formValues.followTime.format("hh:mm A"),
        }),
        ...(formValues.subLeadStatus && { subLeadStatus: formValues.subLeadStatus }),
        leadStatus: formValues.leadStatus,
        callEnd: modalState?.endingTime,
        saveTimestamp: formattedSaveTime,
        remark:formValues?.remark,
    };    
    try {
      let response = await updateLeadAndCallLog(payload);
      if (response?.status == 200) {
        toast.success(response?.data?.message);
        setEndTime(null);
        dispatch(setApiResponsed(null));
        setShowDateField(false);
        setShowRejectedReason(false);
        filterRecords();
        dispatch(resetCallState()); 
        dispatch(openModal({ isOpenModal: false, modalData: null }));
      } else {
      dispatch(setApiResponsed({}));
      dispatch(resetCallState()); 
      dispatch(openModal({ isOpenModal: false, modalData: null }));
      toast.error(response?.response?.data?.error);
    }
    } catch (error) {
      dispatch(setApiResponsed({}));
      dispatch(resetCallState()); 
      dispatch(openModal({ isOpenModal: false, modalData: null }));
      console.log("Error:", error);
    }
};
  return (
  <>
    <form onSubmit={handleSubmit(onSave)}>
      <div className="border border-gray-300 p-2 m-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-2">

          <div className="flex flex-col sm:flex-row items-center justify-evenly border-r border-gray-200">
            <div className="bg-white rounded-full p-2 shadow-xl ring-2 ring-blue-100">
              <StopwatchClock elapsedSeconds={elapsedSeconds} size={160} />
            </div>

            <div>
              <div className="bg-[#F6F6F6] px-2 py-3 border-2 border-gray-100">
                <p className="text-2xl font-[400] text-[#1E2939] font-mono">{formatTime()}</p>
              </div>

              <div className="flex gap-4 pt-2 justify-center">
                {isRunning && (
                  <button onClick={handleStop} type="button" className="px-11 py-2 bg-red-500 text-white">
                    Stop
                  </button>
                )}
                {isIdle && (
                  <button onClick={handleStart} type="button" className="px-11 py-2 bg-[#00A63E] text-white">
                    Start
                  </button>
                )}
                {isStopped && (
                  <button disabled type="button" className="px-11 py-2 bg-[#00A63E] text-white  opacity-50 cursor-not-allowed">
                    Start
                  </button>
                )}
              </div>
            </div>
          </div>

          <div className="m-1 md:col-span-2">
            <h3 className="text-3xl font-[400] mb-2 text-[#1E2939]">Lead Information</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
              <div className="">
                <label className={labelClass}>First Name</label>
                <input
                  type="text"
                  className={inputClass}
                  {...register("firstName")}
                />
              </div>
              <div>
                <label className={labelClass}>Last Name</label>
                <input
                  type="text"
                  className={inputClass}
                  {...register("lastName")}
                />
              </div>
              <div className="">
                <label className={labelClass}> Phone Number </label>
                <input
                  type="text"
                  className={inputClass}
                  {...register("phoneNumber")}
                />
              </div>
              <div>
                <label className={labelClass}>
                  Alternate Number
                </label>
                <input
                  type="text"
                  className={inputClass}
                  {...register("alternateNumber")}
                />
              </div>
              <div>
                <label className={labelClass}>State</label>
                <input type="text" className={inputClass} {...register("state")} />
              </div>
              <div>
                <label className={labelClass}>City</label>
                <input type="text" className={inputClass} {...register("city")} />
              </div>
              <div>
                <label className={labelClass}>Pincode</label>
                <input type="text" className={inputClass} {...register("pincode")} />
              </div>
              <div>
                <Info
                  label="Status"
                  value={modalState?.modalData?.rowdata?.leadStatus}
                />
              </div>
            </div>
            <div className="mt-2">
              <Info
                label="Remarks"
                value={modalState?.modalData?.rowdata?.remark}
                />
            </div>
          </div>
        </div>
      </div>
       {isStopped && (
        <div className="border border-gray-300 p-4 m-4">
          <h3 className="text-3xl font-[400] mb-2 text-[#1E2939]">Lead Status</h3>
          <div className="m-1 grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div>
              <label className={labelClass}>Lead Status</label>
                <select
                  className={`${inputClass} !bg-slate-100`}
                  {...register("leadStatus", { required: true })}
                  onChange={HandleStatusChange}
                >
                  <option value="">Select Status</option>

                  {leadStatusOptions.map((status, index) => (
                    <option key={index} value={status}>
                      {status}
                    </option>
                  ))}

                </select>
                {errors.leadStatus && (
                  <Error title="lead Status is Required" />
                )}
                {showRejectedReason && (
                  <div className="mt-3">
                    <label htmlFor="" className={labelClass}>
                        Rejected Reasons
                      </label>
                      <select
                        placeholder="Select Status"
                        className={`${inputClass} !bg-slate-100`}
                        {...register("subLeadStatus", { required: true })}
                      >
                        <option value="">Select Reasons</option>
                        <option value="NotInterested">
                          Not Interested
                        </option>
                        <option value="HubNotAvailable">
                          Hub Not Available
                        </option>
                        <option value="NotHavingFunds">
                          Not Having Funds
                        </option>
                      </select>
                  </div>
                )}
                {showDateField && (
                  <>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                      <div className="mt-3">
                          <label className={labelClass}>
                            CallBack & FollowUp Date
                          </label>
                          <div className="">
                            <Controller
                              name="followDate"
                              control={control}
                              rules={{ required: true }}
                              render={({ field }) => (
                                <DatePicker
                                  {...field}
                                  format="DD-MM-YYYY"
                                  disabledDate={(current) =>
                                    current && current < dayjs().startOf("day")
                                  }
                                  className="w-full h-[48px] rounded-lg border border-gray-300 px-3 shadow-none focus:shadow-none hover:shadow-none"
                                />
                              )}
                            />
                            {errors.followDate && <Error title="followDate is Required" />}

                          </div>
                      </div>
                      <div className="mt-3">
                        <label className={labelClass}>
                          CallBack & FollowUp Time
                        </label>
                        <div className="">
                          {/* <input
                            type="time"
                            className={inputClass}
                            placeholder="Enter time"
                            min={minTime}
                            {...register("followTime", { required: true })}
                          /> */}
                          <Controller
                            name="followTime"
                            control={control}
                            rules={{ required: true }}
                            render={({ field }) => (
                              <TimePicker
                                {...field}
                                use12Hours
                                format="hh:mm A"
                                minuteStep={5}
                                className="w-full h-[48px] rounded-lg border border-gray-300 px-3 shadow-none focus:shadow-none hover:shadow-none"
                              />
                            )}
                          />
                          {errors.followTime && (
                            <Error title="followTime is Required" />
                          )}
                        </div>
                    </div>

                  </div>
                  </>
                )}
            </div>
            <div>
              <label className={labelClass}>Remark</label>
              <textarea
                {...register("remark", { required: true })}
                cols="5"
                rows="5"
                className={inputClass}
              ></textarea>
              {errors.remark && <Error title="Remark is Required" />}
            </div>
          </div>
          <div className="flex justify-end mt-4">
            <button
              type="submit"
              disabled={!isStopped}
              className={`${formBtn1} ${!isStopped ? "opacity-50 cursor-not-allowed" : ""}`}
            >
              Save
            </button>
          </div>
        </div>
       )}
    </form>
  </>
);
}
function Info({ label, value }) {
  return (
    <div>
      <label className={labelClass}>
        {label}
      </label>
      <div className="min-w-0 box-border block p-2.5 bg-gray-50 w-full text-md font-tb font-medium tracking-tight text-gray-900 rounded-md border-2 border-zinc-200/70">
        <p className="">
          {value || "-----"}
        </p>
      </div>
    </div>
  );
}
